import { render, staticRenderFns } from "./allcontractss.vue?vue&type=template&id=a0f66c72&scoped=true&"
import script from "./allcontractss.vue?vue&type=script&lang=js&"
export * from "./allcontractss.vue?vue&type=script&lang=js&"
import style0 from "./allcontractss.vue?vue&type=style&index=0&id=a0f66c72&scoped=true&lang=css&"
import style1 from "./allcontractss.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f66c72",
  null
  
)

export default component.exports